import { omnisearchHasCorrectionDateTerm } from "./mergeDefaultAndOmnisearch";

/**
 * The merged list's hidden page scope: the tenant, plus the year picker's
 * shipped-year bound.
 *
 * The year is a *default* scope rather than a pinned filter, the same way V2's
 * Manifests screen treats it: when the active search carries a
 * correction/raised-date term (the vendor dashboard's chart drilldowns), the
 * year is dropped. Those charts scope by request/raised date, so keeping the
 * shipped-year bound would silently drop cross-year rows the chart counted —
 * and surfacing a shipped-date override in the visible input is noise. The date
 * term takes over as the grid's time scope instead.
 *
 * `shipDateKey` is a parameter because the two consumers speak different
 * vocabularies for the same date. The `shippingPaperwork` query registers
 * `shipDate` (a column both kinds carry, which is why the year scopes bills of
 * lading too); the Show picker's `processedManifestShowFilterCounts` query is
 * the manifest-only one and registers `shippedDate`.
 */
export function manifestsV3DefaultSearch({
  tenantId,
  shippedDateYear,
  omnisearch,
  shipDateKey,
}: {
  tenantId: string;
  shippedDateYear: number;
  omnisearch: string;
  shipDateKey: "shipDate" | "shippedDate";
}): string {
  if (omnisearchHasCorrectionDateTerm(omnisearch)) {
    return `tenantId:${tenantId}`;
  }
  return `tenantId:${tenantId} ${shipDateKey}:${shippedDateYear}`;
}
